var $1f0dc3b9307be026$exports = {};
document.body.innerHTML = `
<table>
  <tr>
    <th>Key</th>
    <th>Value</th>
  </tr>
  <tr>
    <td>CF_PAGES_BRANCH</td>
    <td>${"production"}</td>
  </tr>
  <tr>
    <td>ENV</td>
    <td>${"production"}</td>
  </tr>
  <tr>
    <td>NODE_ENV</td>
    <td>${"production"}</td>
  </tr>
</table>
`;


//# sourceMappingURL=repo.36466818.js.map
